import { render, staticRenderFns } from "./wode-zuji.vue?vue&type=template&id=66b16168&"
import script from "./wode-zuji.vue?vue&type=script&lang=js&"
export * from "./wode-zuji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports